import { RootScopeEvents } from './root-scope-types';
import { getName } from '../utils/users';

export default angular
  .module('doxy.common.services.intercomFactory', [])
  .factory('intercomFactory', function ($window, $rootScope, intercomConfig) {
    let intercomSettings = null;
    let isVisible = false;

    function formatUser(user, extraData) {
      let plan = !!extraData.purchases[0]
        ? extraData.purchases[0].planId
        : 'Free';
      return user
        ? {
            user_id: user.id,
            user_hash: user.hash,
            name: getName(user),
            email: user.email,
            created_at: user.created,
            trialEnd_at: user.trialEndDate,
            betaAccess: user.betaAccess,
            plan: plan,
            specialty: extraData.specialty,
          }
        : void 0;
    }

    function formatInstitution(institution, extraData) {
      const plan = !!extraData.purchases[0]
        ? extraData.purchases[0].planId
        : null;
      return institution && institution.id
        ? {
            id: institution.id,
            name: institution.name,
            plan: plan,
            created_at: institution.created,
          }
        : void 0;
    }

    function _intercomLoaded() {
      if (angular.isUndefined($window.Intercom)) {
        console.warn('Intercom is not loaded');
        return false;
      }
      return true;
    }

    /**
     * @param {{ [s:string]: any; id: any; } | undefined } user
     * @param {{ id: string; name: string; created: any }} institution
     * @param {boolean} forceBoot
     * @param {{ [s:string] }} extraData
     * @returns {void}
     */
    function _boot(user, institution, forceBoot, extraData) {
      if (user == null) {
        return;
      }

      const company = formatInstitution(institution, extraData);
      const userConfig = formatUser(user, extraData);
      const method = $window.Intercom.booted && !forceBoot ? 'update' : 'boot';
      intercomSettings = angular.extend(
        {
          app_id: intercomConfig.appId,
          company: company,
          hide_default_launcher: true,
        },
        userConfig,
        extraData
      );
      $window.Intercom(method, intercomSettings);
      $window.Intercom('onShow', () => {
        $rootScope.$emit(RootScopeEvents.INTERCOM.SHOW);
        isVisible = true;
      });
      $window.Intercom('onHide', () => {
        $rootScope.$emit(RootScopeEvents.INTERCOM.HIDE);
        isVisible = false;
      });
      $window.Intercom('onUnreadCountChange', (unreadCount) => {
        $rootScope.$emit(
          RootScopeEvents.INTERCOM.UNREAD_COUNT_CHANGE,
          unreadCount
        );
      });
    }

    function boot(user, institution, forceBoot, extraData) {
      if (angular.isUndefined($window.Intercom)) {
        return import('vendor/intercom').then(() => {
          _boot(user, institution, forceBoot, extraData);
        });
      } else {
        _boot(user, institution, forceBoot, extraData);
        return Promise.resolve();
      }
    }

    function update() {
      if (!_intercomLoaded()) return;
      if ($window.Intercom.booted) return $window.Intercom('update');
    }

    function reboot() {
      if (!_intercomLoaded()) return;
      if (intercomSettings) {
        $window.Intercom('boot', intercomSettings);
      }
    }

    function shutdown() {
      if (!_intercomLoaded()) return;
      $window.Intercom('shutdown');
    }

    function show() {
      if (!_intercomLoaded()) return;
      $window.Intercom('show');
    }

    function hide() {
      if (!_intercomLoaded()) return;
      $window.Intercom('hide');
    }

    function showSpace(spaceName) {
      if (!_intercomLoaded()) {
        return;
      }
      $window.Intercom('showSpace', spaceName);
    }

    return {
      boot,
      formatUser,
      reboot,
      show,
      hide,
      shutdown,
      update,
      isVisible() {
        return isVisible;
      },
      showSpace,
    };
  }).name;
